<template>
  <div class="error-container">
    <h1>404 - PAGE NOT FOUND!</h1>
    <p>Sorry but the page you are looking for does not exist, have been removed,</p>
    <p>name changed or its temporarily unavailable</p>
    <button class="btn btn-apply" @click="handleGoBack">Take me back</button>
  </div>
</template>

<script>
import router from './../router.js'

export default {
  methods: {
    handleGoBack () {
      router.go(-2)
    }
  }
}
</script>

<style lang="scss" scoped>
  .error-container {
    height: calc(100vh - 20px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h1 {
      margin-bottom: 40px;
    }
    p {
      margin-bottom: 10px;
    }
    button {
      margin-top: 40px;
      width: 200px;
    }
  }
</style>
